import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-auth-bg-blobs',
  templateUrl: './auth-bg-blobs.component.html',
  styleUrls: ['./auth-bg-blobs.component.scss'],
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthBgBlobsComponent {}
